module.exports = __webpack_public_path__ + "static/media/YF80_5.c2f76752.jpg";